import React from 'react';
import { useSelector } from 'react-redux';
import { Loader } from 'components/Shared/Loader/Loaders';

export const LoaderFullScreen = () => {
  const isFullScreenLoaderVisible = useSelector((state) => state.isFullScreenLoaderVisible);

  return isFullScreenLoaderVisible && <Loader />;
};
